"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * PlumbingWorld-3.0
 * PlumbingWorld API
 *
 * Contact: jspencer@juliusspencer.co.nz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminCustomerContractsApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var AdminCustomerContractsApi = /** @class */ (function (_super) {
    __extends(AdminCustomerContractsApi, _super);
    function AdminCustomerContractsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Adds a staff user to branches for customer contracts
     */
    AdminCustomerContractsApi.prototype.addUserContractBranchesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.username === null || requestParameters.username === undefined) {
                            throw new runtime.RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling addUserContractBranches.');
                        }
                        if (requestParameters.branchIds === null || requestParameters.branchIds === undefined) {
                            throw new runtime.RequiredError('branchIds', 'Required parameter requestParameters.branchIds was null or undefined when calling addUserContractBranches.');
                        }
                        queryParameters = {};
                        if (requestParameters.username !== undefined) {
                            queryParameters['username'] = requestParameters.username;
                        }
                        if (requestParameters.branchIds) {
                            queryParameters['branchIds'] = requestParameters.branchIds;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/staff/branch",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Adds a staff user to branches for customer contracts
     */
    AdminCustomerContractsApi.prototype.addUserContractBranches = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addUserContractBranchesRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Deletes for a user, existing staff user branches for customer contracts and applies those in the request
     */
    AdminCustomerContractsApi.prototype.applyUserContractBranchesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.username === null || requestParameters.username === undefined) {
                            throw new runtime.RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling applyUserContractBranches.');
                        }
                        if (requestParameters.branchIds === null || requestParameters.branchIds === undefined) {
                            throw new runtime.RequiredError('branchIds', 'Required parameter requestParameters.branchIds was null or undefined when calling applyUserContractBranches.');
                        }
                        queryParameters = {};
                        if (requestParameters.username !== undefined) {
                            queryParameters['username'] = requestParameters.username;
                        }
                        if (requestParameters.branchIds) {
                            queryParameters['branchIds'] = requestParameters.branchIds;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/staff/branch",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Deletes for a user, existing staff user branches for customer contracts and applies those in the request
     */
    AdminCustomerContractsApi.prototype.applyUserContractBranches = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.applyUserContractBranchesRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Approves request
     */
    AdminCustomerContractsApi.prototype.approveRequestRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
                            throw new runtime.RequiredError('requestId', 'Required parameter requestParameters.requestId was null or undefined when calling approveRequest.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/requests/{requestId}/approve".replace("{" + "requestId" + "}", encodeURIComponent(String(requestParameters.requestId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CustomerContractRequestFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Approves request
     */
    AdminCustomerContractsApi.prototype.approveRequest = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.approveRequestRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a request or draft if not submitted
     */
    AdminCustomerContractsApi.prototype.createRequestRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/requests",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.CreateUpdateCustomerContractRequestToJSON(requestParameters.createUpdateCustomerContractRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CustomerContractRequestFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a request or draft if not submitted
     */
    AdminCustomerContractsApi.prototype.createRequest = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createRequestRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Deletes a request or draft if not submitted
     */
    AdminCustomerContractsApi.prototype.deleteRequestRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.contractRequestId === null || requestParameters.contractRequestId === undefined) {
                            throw new runtime.RequiredError('contractRequestId', 'Required parameter requestParameters.contractRequestId was null or undefined when calling deleteRequest.');
                        }
                        queryParameters = {};
                        if (requestParameters.contractRequestId !== undefined) {
                            queryParameters['contractRequestId'] = requestParameters.contractRequestId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/requests",
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Deletes a request or draft if not submitted
     */
    AdminCustomerContractsApi.prototype.deleteRequest = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteRequestRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Deletes a staff user from branches for customer contracts
     */
    AdminCustomerContractsApi.prototype.deleteUserContractBranchesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.username === null || requestParameters.username === undefined) {
                            throw new runtime.RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling deleteUserContractBranches.');
                        }
                        if (requestParameters.branchIds === null || requestParameters.branchIds === undefined) {
                            throw new runtime.RequiredError('branchIds', 'Required parameter requestParameters.branchIds was null or undefined when calling deleteUserContractBranches.');
                        }
                        queryParameters = {};
                        if (requestParameters.username !== undefined) {
                            queryParameters['username'] = requestParameters.username;
                        }
                        if (requestParameters.branchIds) {
                            queryParameters['branchIds'] = requestParameters.branchIds;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/staff/branch",
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Deletes a staff user from branches for customer contracts
     */
    AdminCustomerContractsApi.prototype.deleteUserContractBranches = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteUserContractBranchesRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Retrieves details of a contract
     */
    AdminCustomerContractsApi.prototype.getCustomerContractRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
                            throw new runtime.RequiredError('contractId', 'Required parameter requestParameters.contractId was null or undefined when calling getCustomerContract.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/contracts/{contractId}".replace("{" + "contractId" + "}", encodeURIComponent(String(requestParameters.contractId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ContractFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieves details of a contract
     */
    AdminCustomerContractsApi.prototype.getCustomerContract = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerContractRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves a contract request
     */
    AdminCustomerContractsApi.prototype.getCustomerContractRequestRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getCustomerContractRequest.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/request/{id}".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CustomerContractRequestFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieves a contract request
     */
    AdminCustomerContractsApi.prototype.getCustomerContractRequest = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerContractRequestRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves requests that may be filtered
     */
    AdminCustomerContractsApi.prototype.getCustomerContractRequestStatsForBranchRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.branchId === null || requestParameters.branchId === undefined) {
                            throw new runtime.RequiredError('branchId', 'Required parameter requestParameters.branchId was null or undefined when calling getCustomerContractRequestStatsForBranch.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/requests/{branchId}".replace("{" + "branchId" + "}", encodeURIComponent(String(requestParameters.branchId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CustomerContractRequestStatsForBranchFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieves requests that may be filtered
     */
    AdminCustomerContractsApi.prototype.getCustomerContractRequestStatsForBranch = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerContractRequestStatsForBranchRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves requests that may be filtered
     */
    AdminCustomerContractsApi.prototype.getCustomerContractRequestsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.query !== undefined) {
                            queryParameters['query'] = requestParameters.query;
                        }
                        if (requestParameters.branchId !== undefined) {
                            queryParameters['branchId'] = requestParameters.branchId;
                        }
                        if (requestParameters.username !== undefined) {
                            queryParameters['username'] = requestParameters.username;
                        }
                        if (requestParameters.customerId !== undefined) {
                            queryParameters['customerId'] = requestParameters.customerId;
                        }
                        if (requestParameters.customerName !== undefined) {
                            queryParameters['customerName'] = requestParameters.customerName;
                        }
                        if (requestParameters.customerGroup !== undefined) {
                            queryParameters['customerGroup'] = requestParameters.customerGroup;
                        }
                        if (requestParameters.contractId !== undefined) {
                            queryParameters['contractId'] = requestParameters.contractId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/requests",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CustomerContractRequestsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieves requests that may be filtered
     */
    AdminCustomerContractsApi.prototype.getCustomerContractRequests = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerContractRequestsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves headers for a customer\'s contracts from the ERP
     */
    AdminCustomerContractsApi.prototype.getCustomerContractsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.customerId !== undefined) {
                            queryParameters['customerId'] = requestParameters.customerId;
                        }
                        if (requestParameters.customerGroupId !== undefined) {
                            queryParameters['customerGroupId'] = requestParameters.customerGroupId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/customer/contracts",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ContractHeadersFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieves headers for a customer\'s contracts from the ERP
     */
    AdminCustomerContractsApi.prototype.getCustomerContracts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerContractsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves a customer\'s contracts and requests that may be filtered
     */
    AdminCustomerContractsApi.prototype.getCustomerContractsAndRequestsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getCustomerContractsAndRequests.');
                        }
                        queryParameters = {};
                        if (requestParameters.everyday !== undefined) {
                            queryParameters['everyday'] = requestParameters.everyday;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/{customerId}".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CustomerContractsAndRequestsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieves a customer\'s contracts and requests that may be filtered
     */
    AdminCustomerContractsApi.prototype.getCustomerContractsAndRequests = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerContractsAndRequestsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves customer contracts staff for a branch
     */
    AdminCustomerContractsApi.prototype.getCustomerContractsBranchStaffRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.branchId === null || requestParameters.branchId === undefined) {
                            throw new runtime.RequiredError('branchId', 'Required parameter requestParameters.branchId was null or undefined when calling getCustomerContractsBranchStaff.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/staff/branch/{branchId}".replace("{" + "branchId" + "}", encodeURIComponent(String(requestParameters.branchId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.StaffListFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieves customer contracts staff for a branch
     */
    AdminCustomerContractsApi.prototype.getCustomerContractsBranchStaff = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerContractsBranchStaffRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves pricing categories that have no sections
     */
    AdminCustomerContractsApi.prototype.getParentPricingCategoriesRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/pricing/category/parent",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.PricingCategoriesFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieves pricing categories that have no sections
     */
    AdminCustomerContractsApi.prototype.getParentPricingCategories = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getParentPricingCategoriesRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves pricing catgegories based on the search term
     */
    AdminCustomerContractsApi.prototype.getPricingCategoriesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.searchTerm === null || requestParameters.searchTerm === undefined) {
                            throw new runtime.RequiredError('searchTerm', 'Required parameter requestParameters.searchTerm was null or undefined when calling getPricingCategories.');
                        }
                        queryParameters = {};
                        if (requestParameters.searchTerm !== undefined) {
                            queryParameters['searchTerm'] = requestParameters.searchTerm;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/pricing/category",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.PricingCategoriesFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieves pricing catgegories based on the search term
     */
    AdminCustomerContractsApi.prototype.getPricingCategories = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPricingCategoriesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Processes approved contract requests for Dynamics
     */
    AdminCustomerContractsApi.prototype.processApprovedCustomerContractRequestsRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/requests/processApproved",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Processes approved contract requests for Dynamics
     */
    AdminCustomerContractsApi.prototype.processApprovedCustomerContractRequests = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.processApprovedCustomerContractRequestsRaw(initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Rejects request
     */
    AdminCustomerContractsApi.prototype.rejectRequestRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
                            throw new runtime.RequiredError('requestId', 'Required parameter requestParameters.requestId was null or undefined when calling rejectRequest.');
                        }
                        queryParameters = {};
                        if (requestParameters.comment !== undefined) {
                            queryParameters['comment'] = requestParameters.comment;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/requests/{requestId}/reject".replace("{" + "requestId" + "}", encodeURIComponent(String(requestParameters.requestId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CustomerContractRequestFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Rejects request
     */
    AdminCustomerContractsApi.prototype.rejectRequest = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.rejectRequestRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Search products by query
     */
    AdminCustomerContractsApi.prototype.searchContractProductsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.page === null || requestParameters.page === undefined) {
                            throw new runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling searchContractProducts.');
                        }
                        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
                            throw new runtime.RequiredError('pageSize', 'Required parameter requestParameters.pageSize was null or undefined when calling searchContractProducts.');
                        }
                        queryParameters = {};
                        if (requestParameters.query !== undefined) {
                            queryParameters['query'] = requestParameters.query;
                        }
                        if (requestParameters.categoryId !== undefined) {
                            queryParameters['categoryId'] = requestParameters.categoryId;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['pageSize'] = requestParameters.pageSize;
                        }
                        if (requestParameters.customerId !== undefined) {
                            queryParameters['customerId'] = requestParameters.customerId;
                        }
                        if (requestParameters.countOnly !== undefined) {
                            queryParameters['countOnly'] = requestParameters.countOnly;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/product",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.SearchRequestToJSON(requestParameters.searchRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.PagedContractProductsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Search products by query
     */
    AdminCustomerContractsApi.prototype.searchContractProducts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchContractProductsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates pricing categories (margins)
     */
    AdminCustomerContractsApi.prototype.updatePricingCategoriesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.pricingCategory === null || requestParameters.pricingCategory === undefined) {
                            throw new runtime.RequiredError('pricingCategory', 'Required parameter requestParameters.pricingCategory was null or undefined when calling updatePricingCategories.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/pricing/category",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.pricingCategory.map(models_1.PricingCategoryToJSON),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Updates pricing categories (margins)
     */
    AdminCustomerContractsApi.prototype.updatePricingCategories = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updatePricingCategoriesRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates a request or draft if not submitted
     */
    AdminCustomerContractsApi.prototype.updateRequestRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.contractRequestId === null || requestParameters.contractRequestId === undefined) {
                            throw new runtime.RequiredError('contractRequestId', 'Required parameter requestParameters.contractRequestId was null or undefined when calling updateRequest.');
                        }
                        queryParameters = {};
                        if (requestParameters.contractRequestId !== undefined) {
                            queryParameters['contractRequestId'] = requestParameters.contractRequestId;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/customer-contracts/requests",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.CreateUpdateCustomerContractRequestToJSON(requestParameters.createUpdateCustomerContractRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CustomerContractRequestFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a request or draft if not submitted
     */
    AdminCustomerContractsApi.prototype.updateRequest = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateRequestRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AdminCustomerContractsApi;
}(runtime.BaseAPI));
exports.AdminCustomerContractsApi = AdminCustomerContractsApi;
